import React, { useState, useEffect } from "react";
import { useDispatch } from "react-redux";
import {
  handleChangeOrdertypeGlobal,
  onChangeCheckBoxDeliveryGlobal,
  shipmentAdditionalServicesAttributesParams,
} from "../../../../../helpers/OrdersFunctionsGlobal";
import { postServiceShiping } from "../../../../../redux/Actions/Service/serviceAction";
import { MainBlock, SelectForm } from "../../../../common/Buttons";
import ShippingComponent from "../../../../common/GlobalModals/Orders/ShippingComponent";
import { shipment_types_options } from "../../../../../helpers/GlobalOptions";

function ServiceRepairShipment({
  shipmentAddr,
  service,
  shipments,
  id,
  onChangeCol,
}) {
  const dispatch = useDispatch();

  const [state, setState] = useState({
    carrying: false,
    cod: false,
    sendingDocuments: false,
    deliveryTime: false,
    deliveryOnSaturday: false,
    terminalSelected: undefined,
    swap: false,
    deliveryTimeHours: ["", ""],
    who: "",
    order_type: "dpd",
    delivery: "dpd_b2c",
    suppliers: undefined,
    weight: 1,
    pack: 1,
    cod_amount: "",
    order_return: "",
    lp_express_sizes: undefined,
    shipping_loading: false,
  });

  const [shipmentAddress, setShipmentAddress] = useState({
    ...shipmentAddr,
    comment: "",
  });

  const [orderRows, setOrderRows] = useState(
    service.service_rows
      ? service.service_rows.map((e) => ({
        id: e.id,
        quantity: 1,
        product_name: e.item_name,
        unit_price_tax_incl: e.item_price,
      }))
      : []
  );

  const [selectedOrderRows, setSelectedOrderRows] = useState(
    service.service_rows
      ? service.service_rows.map((e) => ({
        id: e.id,
        selected: true,
        isUsed: false,
      }))
      : []
  );

  const [errors, setErrors] = useState({});

  //

  useEffect(() => {
    console.log(!!shipmentAddr, "test");
    if (Object.entries(shipmentAddr).length === 0) {
      console.log("atsaukti");
      return;
    }
    console.log("Praeiti");
    setShipmentAddress({
      comment: "",
      ...shipmentAddress,
      ...shipmentAddr,
    });
  }, [shipmentAddr]);


  useEffect(() => {
    // cia
    if (service.service_rows) {
      const cod_amount = service.service_rows
        .filter((f) => selectedOrderRows.includes(f.id))
        .reduce((acc, cur) => acc + cur.item_price, 0);
      setState({
        ...state,
        cod_amount,
      });
      const serviceOr = service.service_rows
        ? service.service_rows.map((e) => ({
          id: e.id,
          quantity: 1,
          product_name: e.item_name,
          unit_price_tax_incl: e.item_price,
        }))
        : [];

      setOrderRows(serviceOr);
    }
  }, [service.service_rows, selectedOrderRows, state.order_type]);

  // Functions

  const handleChangeText = (e, where) => {
    if (where == null) {
      setState(prev => ({
        ...prev,
        [e.target.name]: e.target.value,
      }));
    } else {
      setShipmentAddress({
        ...shipmentAddress,
        [e.target.name]: e.target.value,
      });
    }
  };

  const createShipping = () => {
    setState({
      ...state,
      shipping_loading: true,
    });

    const orderTypeAtTheStore = state.order_type === "at_the_store";
    // Model
    let orderVariables = {
      shipment: {
        // order_id: 7156,
        // service_order_id: 7156,
        // service_order_type: state.order_type,
        // service_row_ids: service.service_rows.map((e) => e.id),
        order_row_ids: [],
        // order_row_ids: service.service_rows.map((e) => e.id),
        shipment_type: state.order_type,
        packets: state.pack,
        // weight: state.weight,
        weight: orderTypeAtTheStore ? 0.1 : state.weight,

        pickup_address_id: state.suppliers,
        shipment_address_attributes: {
          company: "",
          name: shipmentAddress.firstname + " " + shipmentAddress.lastname,
          country_id: shipmentAddress.country_id,
          address: shipmentAddress.street,
          city: shipmentAddress.city,
          postal_code: shipmentAddress.postal_code,
          phone: shipmentAddress.phone,
          email: shipmentAddress.other,
          comment: shipmentAddress.comment,
          parcel_terminal_id: state.terminalSelected,
        },
        shipment_order_rows_attributes: orderRows
          .filter((e) =>
            selectedOrderRows.find((fe) => fe.id == e.id)?.selected
          )
          .map((e) => ({
            quantity: e?.quantity,
            title: e.product_name,
            price: e.unit_price_tax_incl,
            order_row_id: null,
            service_row_id: e.id,
          })),
        shipment_additional_services_attributes: shipmentAdditionalServicesAttributesParams({
          ...state,
          type: state.order_type,
        }),
      },
    };

    dispatch(postServiceShiping(id, orderVariables)).then((res) => {
      if (res.success) {
        setErrors({});
      } else {
        setErrors(res.errors);
      }
      setState({
        ...state,
        shipping_loading: false,
      });
    });
  };

  const handleCheckBoxOrdersSelected = (id) => {
    console.log(id);
    const newChecked = [...selectedOrderRows];
    const currentIndexCheck = newChecked.findIndex((e) => e.id == id);

    if (currentIndexCheck == -1) {
      newChecked.push({
        id: id,
        selected: true,
        isUsed: false,
      });
    } else {
      newChecked.splice(currentIndexCheck, 1);
    }
    setSelectedOrderRows(newChecked);
  };

  return (
    <>
      {/*  */}

      <MainBlock
        color={"#00aaa0"}
        custom={true}
        action={true}
        onChange={onChangeCol}
      >
        <div className="d-flex align-items-center justify-content-between">
          <div className="w-50" onClick={onChangeCol}>
            Shipping
          </div>
          <SelectForm
            options={shipment_types_options.filter(
              option => !["matkahuolto", "posti"].includes(option.value)
            )}
            selector="order_type"
            value={state.order_type}
            onChange={(e) =>
              setState({
                ...handleChangeOrdertypeGlobal(
                  e,
                  state.order_type,
                  shipmentAddress,
                  shipmentAddress
                ),
              })
            }
          />
        </div>
      </MainBlock>
      {/*  */}
      <div className="bg-silver">
        <ShippingComponent
          order_type={state.order_type}
          delivery={state.delivery}
          mode="Servisas"
          shipping_address_edit={shipmentAddress}
          terminalSelected={state.terminalSelected}
          order_rows={orderRows}
          shipments={shipments}
          selectedOrderRows={selectedOrderRows}
          errors={errors}
          variables={state}
          handleChangeText={handleChangeText}
          handleCheckBoxOrdersSelected={handleCheckBoxOrdersSelected}
          onChangeCheckBoxDelivery={(e) =>
            setState({
              ...state,
              ...onChangeCheckBoxDeliveryGlobal(e, state.delivery, state.terminalSelected, state.savedTerminalSelected),
            })
          }
          createShipping={createShipping}
        //
        />
      </div>
    </>
  );
}

export default ServiceRepairShipment;
